import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function AdminLogin() {
  const { login, user, error } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => { if (user && user.role === "admin") navigate("/admin", { replace: true }); }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const ok = await login(email, password);
    setBusy(false);
    if (ok) navigate("/admin", { replace: true });
  };

  return (
    <div className="min-h-screen bg-background grid md:grid-cols-2" data-testid="admin-login-page">
      <div className="hidden md:flex flex-col justify-between p-12 bg-lime text-black">
        <Link to="/" className="font-heading text-2xl font-black tracking-tighter">PITCH.LU</Link>
        <div>
          <div className="font-heading text-6xl font-black uppercase tracking-tighter leading-[0.9]">
            Control<br />room.
          </div>
          <p className="mt-6 text-black/70 max-w-md text-lg">Triage applications, schedule pitches, publish episodes. Fast.</p>
        </div>
        <div className="text-xs font-mono uppercase tracking-widest">Host access only</div>
      </div>
      <div className="flex items-center justify-center p-8">
        <form onSubmit={submit} className="w-full max-w-md">
          <div className="text-xs font-mono uppercase tracking-[0.3em] text-lime mb-4">Host Login</div>
          <h1 className="font-heading text-4xl font-black uppercase tracking-tighter mb-10">Sign in</h1>
          <div className="space-y-6">
            <div>
              <Label className="text-xs font-mono uppercase tracking-widest text-white/50">Email</Label>
              <Input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-2 bg-black border-white/10 rounded-none h-12 text-white focus-visible:ring-lime" />
            </div>
            <div>
              <Label className="text-xs font-mono uppercase tracking-widest text-white/50">Password</Label>
              <Input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-2 bg-black border-white/10 rounded-none h-12 text-white focus-visible:ring-lime" />
            </div>
            {error && <div data-testid="login-error" className="text-danger text-sm font-mono">{error}</div>}
            <button
              data-testid="login-submit"
              disabled={busy}
              type="submit"
              className="w-full py-4 bg-lime text-black font-heading font-black uppercase tracking-wider hover:scale-[1.02] transition-transform disabled:opacity-50"
            >
              {busy ? "Signing in…" : "Sign in →"}
            </button>
          </div>
          <Link to="/" className="mt-8 inline-block text-xs font-mono uppercase tracking-widest text-white/40 hover:text-lime">← Back to site</Link>
        </form>
      </div>
    </div>
  );
}
